<template>
  <div class="notice-template">
    <template v-if="features.length > 0">
      <b-carousel v-model="currentSlide" :interval="0" no-animation no-wrap class="notice-carousel">
        <b-carousel-slide v-for="(item, idx) in features" :key="idx">
          <template #img>
            <div class="notice-slide">
              <div class="notice-slide-header">
                <h6 class="notice-feature-title">
                  {{ item.title }}
                  <span v-if="item.plan" class="notice-plan-badge" :class="planClass(item.plan)">
                    {{ item.plan }}
                  </span>
                </h6>
              </div>

              <div v-if="item.image" class="notice-feature-image">
                <img :src="item.image" :alt="item.title" />
              </div>

              <p class="notice-feature-desc">{{ item.description }}</p>
              <p v-if="item.isAi" class="notice-ai-note">
                * 본 기능은 Pro Plus 또는 AI Only(Enterprise) 플랜 이용자에게 제공됩니다.
              </p>
            </div>
          </template>
        </b-carousel-slide>
      </b-carousel>

      <div class="notice-nav">
        <button class="notice-nav-btn" :disabled="currentSlide === 0" @click="currentSlide--">
          <b-icon icon="chevron-left" />
        </button>
        <div class="notice-indicators">
          <span
            v-for="(item, idx) in features"
            :key="idx"
            class="notice-dot"
            :class="{ active: currentSlide === idx }"
            @click="currentSlide = idx"
          ></span>
        </div>
        <button
          class="notice-nav-btn"
          :disabled="currentSlide === features.length - 1"
          @click="currentSlide++"
        >
          <b-icon icon="chevron-right" />
        </button>
      </div>
      <p class="notice-slide-counter">{{ currentSlide + 1 }} / {{ features.length }}</p>
    </template>
    <p v-else class="notice-empty">등록된 공지가 없습니다.</p>

    <div class="notice-footer">
      <p class="notice-contact">문의: ERT 채널톡 또는 info@qesg.co.kr</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoticeTemplate',
  data() {
    return {
      currentSlide: 0,
      features: [
        {
          title: '에디터 폰트 크기 조절',
          plan: 'Basic',
          description: '에디터 내부에서 폰트 크기를 직접 조절할 수 있습니다.',
          image:
            'https://cdn.qesg.co.kr/sources/%ED%8F%B0%ED%8A%B8%ED%81%AC%EA%B8%B0%EC%A1%B0%EC%A0%88.png'
        },
        {
          title: '댓글 이미지 첨부',
          plan: 'Pro',
          description: '댓글에 이미지를 첨부하여 시각적으로 의견을 전달할 수 있습니다.',
          image:
            'https://cdn.qesg.co.kr/sources/%EB%8C%93%EA%B8%80%20%EC%9D%B4%EB%AF%B8%EC%A7%80%20%EC%B6%94%EA%B0%80.png'
        },
        {
          title: 'AI 재작성 창 최소화 & 다중 세션',
          plan: 'Pro Plus',
          description: 'AI 재작성 창을 최소화하고, 여러 작업을 동시에 진행할 수 있습니다.',
          image:
            'https://cdn.qesg.co.kr/sources/AI%EC%9E%AC%EC%9E%91%EC%84%B1%EC%B5%9C%EC%86%8C%ED%99%94.png',
          isAi: true
        },
        {
          title: '데이터 테이블 AI 분석',
          plan: 'Pro Plus',
          description: '데이터 테이블 수치를 AI가 분석하여 인사이트를 제공합니다.',
          image:
            'https://cdn.qesg.co.kr/sources/AI%EB%8D%B0%EC%9D%B4%ED%84%B0%EB%B6%84%EC%84%9D.png',
          isAi: true
        },
        {
          title: '텍스트 박스 → 비즈니스 케이스 전환',
          plan: 'Pro',
          description: '텍스트 박스를 비즈니스 케이스로 전환하여 콘텐츠를 재사용할 수 있습니다.',
          image:
            'https://cdn.qesg.co.kr/sources/%EB%B9%84%EC%A6%88%EB%8B%88%EC%8A%A4%EC%BC%80%EC%9D%B4%EC%8A%A4%EB%A1%9C%EB%B3%80%EA%B2%BD.png'
        }
      ]
    };
  },
  methods: {
    planClass(plan) {
      if (plan === 'Pro Plus') return 'plan-pro-plus';
      if (plan === 'Pro') return 'plan-pro';
      if (plan === 'Basic') return 'plan-basic';
      return '';
    }
  }
};
</script>

<style scoped>
.notice-template {
  line-height: 1.6;
}

.notice-carousel {
  height: 450px;
}

.notice-slide {
  padding: 8px 4px;
  height: 450px;
  overflow-y: auto;
}

.notice-slide-header {
  margin-bottom: 12px;
}

.notice-feature-title {
  font-weight: 700;
  font-size: 1rem;
  margin: 0;
}

.notice-plan-badge {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  vertical-align: middle;
  margin-left: 4px;
}

.plan-basic {
  background: #e6fafb;
  color: #00b5c0;
}

.plan-pro {
  background: #e6f5f6;
  color: #008c95;
}

.plan-pro-plus {
  background: #e2f0ee;
  color: #006369;
}

.notice-feature-image {
  margin-bottom: 12px;
  border-radius: 8px;
  overflow: hidden;
  background: #f5f5f5;
}

.notice-feature-image img {
  width: 100%;
  max-height: 300px;
  object-fit: contain;
  display: block;
}

.notice-feature-desc {
  margin: 0;
  color: #444;
  font-size: 0.9rem;
}

.notice-ai-note {
  margin: 8px 0 0;
  padding: 6px 10px;
  background: #f0f4f8;
  border-left: 3px solid #006369;
  color: #555;
  font-size: 0.8rem;
  line-height: 1.5;
  border-radius: 0 4px 4px 0;
}

.notice-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 16px;
}

.notice-nav-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #ddd;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  color: #333;
  transition: background 0.15s;
}

.notice-nav-btn:hover:not(:disabled) {
  background: #f0f0f0;
}

.notice-nav-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.notice-indicators {
  display: flex;
  gap: 6px;
}

.notice-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ddd;
  cursor: pointer;
  transition: background 0.15s;
}

.notice-dot.active {
  background: #008c95;
}

.notice-slide-counter {
  text-align: center;
  font-size: 0.8rem;
  color: #999;
  margin: 6px 0 0;
}

.notice-empty {
  text-align: center;
  color: #999;
  padding: 40px 0;
}

.notice-footer {
  margin-top: 20px;
  padding-top: 12px;
  border-top: 1px solid #eee;
}

.notice-contact {
  color: #888;
  font-size: 0.85rem;
  margin-bottom: 0;
}
</style>
